import { CardHeader } from 'bricks-ui/packages/bricks-ui';

export default CardHeader;
